import moment from 'moment'
import { Route, IndexRedirect, IndexRoute, Redirect } from 'react-router'

import SubsPage from 'app/pages/SubsPage'
import ChildrenPage from 'app/pages/ChildrenPage'
import AppsContainer from 'app/containers/Apps/AppsContainer'
import FundContainer from 'app/containers/Apps/FundContainer'

import FundApp from 'app/components/Apps/FundApp'
import Polls from 'app/components/Apps/FundApp/Polls'
import PollEdit from 'app/components/Apps/FundApp/PollEdit'
import PollsHome from 'app/components/Apps/FundApp/PollsHome'
import PollContainer from 'app/containers/Apps/fund/PollContainer'

import * as services from 'app/common/constants/services'
import YaKlassPage from 'app/pages/YaKlassPage'

// Дневник
import { DnevnikHomePage, DnevnikJournalPage } from 'app/pages/DnevnikPage'
import EventsPage from 'app/pages/EventsPage'
import ChildEventsContainer from 'app/containers/Events/ChildEventsContainer'
import EventsListContainer from 'app/containers/Events/EventsListContainer'

import App from 'app/components/App'

import ProfilePage from 'app/pages/ProfilePage'
import IdentifiersPage from 'app/pages/IdentifiersPage'
import AboutPage from 'app/pages/AboutPage'

import {
  CatalogItemsPage,
  CatalogDetailsPage,
  CatalogCartPage,
  CatalogOptionsPage,
  CatalogOrderHistoryPage,
  CatalogOrderPaymentPage,
} from 'app/pages/ShopPage'

import {
  CafeteriaMenuPage,
  CafeteriaPurchasesPage,
  CafeteriaOrdersPage,
  CafeteriaSchedulePage,
  CafeteriaFinancesPage,
  CafeteriaPaymentOrdersPage,
  CafeteriaSubsidiesPage,
  CafeteriaOrderRequestsPage,
  CafeteriaSettingsPage,
  CafeteriaFundPage,
  CafeteriaCompensationPage,
} from 'app/pages/CafeteriaPage'

import {
  MyFinancesPage,
  FinancesFundPage,
} from 'app/pages/FinancesPage'

import PassagesPage from 'app/pages/PassagesPage'
import PassagesList from 'app/components/Apps/Passages/PassagesList'

import StatementsPage, { statementSections } from 'app/pages/StatementsPage'

import HelpPage, { sendUsSections } from 'app/pages/HelpPage'
import { dateFormat, monthFormat, params, slug } from './routePaths'


const routes = () => (
  <Route path="/">
    <Route component={App}>

      {/* Внешнее приложение ЯКласс */}
      <Route path="external">
        <Route path={services.EXT_YACLASS} component={YaKlassPage} />
      </Route>

      {/* Магазин */}
      <Route path="shop">
        <IndexRedirect to="catalog" />
        <Route path="catalog">
          <IndexRedirect to="category" />
          <Route path="category(/**)" component={CatalogItemsPage} />
          <Route path="product(/**)/:productSlug" component={CatalogDetailsPage} />
        </Route>
        <Route path="cart">
          <IndexRedirect to="orderlist" />
          <Route path=":step" component={CatalogCartPage} />
        </Route>
        <Route path="options" component={CatalogOptionsPage} />
        <Route path="history">
          <IndexRoute component={CatalogOrderHistoryPage} />
          <Route path="order/:id/:number" component={CatalogOrderPaymentPage} />
        </Route>
      </Route>

      {/* Настройки детей */}
      {/* <Route path="settings/:id" component={ChildSettingsPage} />
      <Route path="settings" component={ChildSettingsPage} /> */}

      {/* Профиль */}
      <Route path="profile/change/:field" component={ProfilePage} />
      <Route path="profile/change" component={ProfilePage} />
      <Route path="profile" component={ProfilePage} />

      {/* Дети */}
      <Route path="children">
        <IndexRedirect to={`${moment().format(dateFormat)}`} />
        <Route path=":date" component={ChildrenPage} />
      </Route>

      {/* Приложения -- id: идентификатор ребенка */}
      <Route path="apps">
        <IndexRoute component={SubsPage} />
        <Route path={slug(params.studentID)} component={AppsContainer}>

          {/* ПРОХОДНАЯ */}
          <Route path="access" component={PassagesPage}>
            <IndexRedirect to={`${moment().format(dateFormat)}`} />
            <Route path=":date(/:date2)" component={PassagesList} />
          </Route>

          {/* СТОЛОВАЯ */}
          <Route path="cafeteria">
            <IndexRedirect to="general" />
            <Route path={slug(params.schoolType)}>
              <IndexRedirect to="menu" />

              {/* Раздел "Меню" */}
              <Route path="menu" component={CafeteriaMenuPage}>
                <IndexRedirect to={`${moment().format(dateFormat)}`} />
                <Route path=":date" />
                <Route path=":date/:categoryId" />
              </Route>

              {/* Раздел "Заказы" */}
              <Route path="orders" component={CafeteriaOrdersPage}>
                <IndexRedirect to={`${moment().format(monthFormat)}`} />
                <Route path=":date" />
              </Route>

              {/* Раздел "Заявки на класс" */}
              <Route path="orderRequests" component={CafeteriaOrderRequestsPage}>
                <IndexRedirect to={`${moment().format(monthFormat)}`} />
                <Route path={slug(params.date)} />
              </Route>

              {/* Раздел "Покупки" */}
              <Route path="purchases" component={CafeteriaPurchasesPage}>
                <IndexRedirect to={`${moment().format(monthFormat)}`} />
                <Route path=":date" />
              </Route>

              {/* Раздел "График питания" */}
              <Route path="schedule" component={CafeteriaSchedulePage}>
                <IndexRedirect to={`${moment().format(monthFormat)}`} />
                <Route path=":date" />
              </Route>

              {/* Раздел "Финансы" */}
              <Route path="finances" component={CafeteriaFinancesPage}>
                <IndexRedirect to={`${moment().format(monthFormat)}`} />
                <Route path=":date" />
              </Route>

              {/* Раздел "Квитанции" */}
              <Route path="paymentOrders" component={CafeteriaPaymentOrdersPage} />

              {/* Раздел "Дотации" */}
              <Route path="subsidies" component={CafeteriaSubsidiesPage}>
                <IndexRedirect to={`${moment().format(monthFormat)}`} />
                <Route path=":date" />
              </Route>

              {/* Раздел "Компенсация" */}
              <Route path="compensation" component={CafeteriaCompensationPage}>
                <Route path={slug(params.section)} component={CafeteriaCompensationPage}>
                  <Route path={slug(params.supplierID)} component={CafeteriaCompensationPage}>
                    <Route path={slug(params.periodFrom)}>
                      <Route path={slug(params.periodTo)}>
                        <Route path={slug(params.withdrawID)} />
                      </Route>
                    </Route>
                  </Route>
                </Route>
              </Route>

              {/* Раздел "Настройки" */}
              <Route path="settings" component={CafeteriaSettingsPage}>
                <Route path=":section" component={CafeteriaSettingsPage} />
              </Route>

              {/* Раздел "Пополнить" */}
              <Route path="fund" component={CafeteriaFundPage}>
                <IndexRedirect to="refill" />
                <Route path=":type" component={CafeteriaFundPage}>
                  <Route path=":target" component={CafeteriaFundPage}>
                    <Route path=":order" component={CafeteriaFundPage}>
                      <Route path=":step" component={CafeteriaFundPage}>
                        <Route path=":targetId" component={CafeteriaFundPage} />
                      </Route>
                    </Route>
                  </Route>
                </Route>
              </Route>
            </Route>
          </Route>

          {/* ДНЕВНИК */}
          <Route path="dnevnik">
            <IndexRedirect to="home" />
            <Route path="home" component={DnevnikHomePage}>
              <Route path={slug(params.classID)}>
                <Route path={slug(params.date)} />
              </Route>
            </Route>
            <Route path="journal" component={DnevnikJournalPage}>
              <Route path={slug(params.classID)}>
                <Route path={`${slug(params.date)}(/${slug(params.summary)})`} />
              </Route>
            </Route>
          </Route>

          <Route path=":type" component={SubsPage} />
          <IndexRoute component={SubsPage} />
        </Route>
      </Route>

      {/* Приложения -- id: идентификатор школы */}
      <Route path="app">
        <IndexRedirect to="0" />
        <Route path=":schoolId" component={FundContainer}>
          <IndexRedirect to="fund" />

          {/* Фонд */}
          <Route path="fund" component={FundApp}>
            <IndexRedirect to="polls" />
            {/* <Route path="bills" component={Empty} /> */}
            <Route path="polls|mypolls" component={Polls} />
            <Route path=":type" component={Polls}>
              <IndexRoute component={PollsHome} />
              <Route path=":pollId" component={PollContainer} />
              <Route path=":pollId/edit" component={PollEdit} />
            </Route>
          </Route>
        </Route>
      </Route>

      {/* Раздел финансы */}
      <Route path="finances">
        <IndexRedirect to="my" />
        <Route path="my" component={MyFinancesPage}>
          <IndexRedirect to={`${moment().format(monthFormat)}`} />
          <Route path=":date" />
        </Route>
        <Route path="fund" component={FinancesFundPage}>
          <IndexRedirect to="refill" />
          <Route path=":type" component={FinancesFundPage}>
            <Route path=":target" component={FinancesFundPage}>
              <Route path=":order" component={FinancesFundPage}>
                <Route path=":step" component={FinancesFundPage}>
                  <Route path=":targetId" component={FinancesFundPage} />
                </Route>
              </Route>
            </Route>
          </Route>
        </Route>
      </Route>

      {/* Идентификаторы */}
      <Route path="identifiers" component={IdentifiersPage}>
        <Route path=":id" component={IdentifiersPage} />
      </Route>

      {/* Раздел События */}
      <Route path="events" component={EventsPage}>
        <IndexRoute component={ChildEventsContainer} />
        <Route path=":id" component={ChildEventsContainer}>
          <IndexRedirect to="all" />
          <Route path=":type" component={EventsListContainer} />
        </Route>
      </Route>

      {/* Родительский контроль */}
      <Route path="statements" component={StatementsPage}>
        <IndexRedirect to={statementSections.VIEW} />
        <Route path=":section" component={StatementsPage}>
          <Route path=":statementId" component={StatementsPage} />
        </Route>
      </Route>

      {/* Раздел помощи -- временно основан на Родительском контроле */}
      <Route path="assistance" component={HelpPage}>
        <IndexRedirect to={sendUsSections.VIEW} />
        <Route path=":section" component={HelpPage}>
          <Route path=":messageId" component={HelpPage} />
        </Route>
      </Route>

      {/* <Route path="assistance">
        <IndexRedirect to="instruction" /> */}
      {/* <Route path="instruction" component={Empty} />
      <Route path="faq" component={Empty} /> */}
      {/* <Route path="ask" component={Ask} />
      <Route path="support" component={ChatContainer}>
        <Route path=":ticketId" component={MessagesContainer} />
      </Route>
    </Route> */}

      {/* Раздел "о приложении" */}
      <Route path="about" component={AboutPage} />


    </Route>
    {/* end AppContainer */}

    <IndexRedirect to="/children" />
    <Redirect from="transition/payment" to="/finances/fund/refill/self/primary/step2" />
    <Redirect from="*" to="/" />
  </Route>
)

export default routes
